import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-project-property.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasProjectPropertyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasProjectPropertyEntity = useAppSelector(state => state.aidasProjectProperty.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasProjectPropertyDetailsHeading">AidasProjectProperty</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasProjectPropertyEntity.id}</dd>

          <dt>
            <span id="value">Value</span>
          </dt>
          <dd>{aidasProjectPropertyEntity.value}</dd>
          <dt>Aidas Project</dt>
          <dd>{aidasProjectPropertyEntity.aidasProject ? aidasProjectPropertyEntity.aidasProject.name : ''}</dd>
          <dt>Aidas Properties</dt>
          <dd>{aidasProjectPropertyEntity.aidasProperties ? aidasProjectPropertyEntity.aidasProperties.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-project-property" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-project-property/${aidasProjectPropertyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasProjectPropertyDetail;
